import { createStore } from 'vuex'
import { getSystemConfig } from '@/api/system'
import { getAdminSessionList } from '@/api/chat'
import { rewriteConfigMediaUrls } from '@/utils/mediaUrl'
import { devError } from '@/utils/devConsole'

function readStoredSystemConfig() {
  try {
    const raw = JSON.parse(localStorage.getItem('systemConfig') || '{}')
    return rewriteConfigMediaUrls(raw)
  } catch {
    return {}
  }
}

export default createStore({
  state: {
    token: sessionStorage.getItem('token') || '',
    userInfo: JSON.parse(sessionStorage.getItem('userInfo') || '{}'),
    // 系统配置（用于布局显示网站标题/Logo等）
    systemConfig: readStoredSystemConfig(),
    // 客服聊天未读消息总数（用于侧边栏角标）
    chatUnreadTotal: 0
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    systemConfig: state => state.systemConfig,
    chatUnreadTotal: state => state.chatUnreadTotal
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      sessionStorage.setItem('token', token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    CLEAR_TOKEN(state) {
      state.token = ''
      sessionStorage.removeItem('token')
    },
    CLEAR_USER_INFO(state) {
      state.userInfo = {}
      sessionStorage.removeItem('userInfo')
    },
    SET_SYSTEM_CONFIG(state, config) {
      state.systemConfig = rewriteConfigMediaUrls(config || {})
      localStorage.setItem('systemConfig', JSON.stringify(state.systemConfig))
    },
    SET_CHAT_UNREAD_TOTAL(state, total) {
      state.chatUnreadTotal = total
    }
  },
  actions: {
    resolveAdminId({ getters }) {
      const userInfo = getters.userInfo || {}
      const rawId = userInfo.id ?? userInfo.userId ?? userInfo.adminId
      const numId = Number(rawId)
      if (!Number.isNaN(numId) && numId > 0) return numId
      return 1
    },
    login({ commit }, { token, userInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
    },
    logout({ commit }) {
      commit('CLEAR_TOKEN')
      commit('CLEAR_USER_INFO')
    },
    async loadSystemConfig({ commit, state }) {
      const res = await getSystemConfig()
      // 后端返回 { code, message, config: { key: value } }
      const raw = (res && res.config && typeof res.config === 'object') ? res.config : (res || {})
      commit('SET_SYSTEM_CONFIG', raw)
      const config = state.systemConfig
      // 同步浏览器标题（可选，但体验更好）
      const title = config.site_name || config.siteTitle
      if (title) document.title = title
      return config
    },
    // 拉取客服未读消息总数（会话列表里各 session.unreadCount 之和）
    async fetchChatUnreadCount({ commit, getters }) {
      try {
        const userInfo = getters.userInfo || {}
        const rawId = userInfo.id ?? userInfo.userId ?? userInfo.adminId
        const adminId = (!Number.isNaN(Number(rawId)) && Number(rawId) > 0) ? Number(rawId) : 1
        const res = await getAdminSessionList(adminId)
        // 兼容 { code, data } 与直接数组
        let list = []
        if (res && res.code === 200 && res.data != null) {
          list = Array.isArray(res.data) ? res.data : (res.data.list ? res.data.list : [])
        } else if (Array.isArray(res)) {
          list = res
        } else if (res && res.data) {
          list = Array.isArray(res.data) ? res.data : []
        }
        const total = list.reduce((sum, s) => sum + (Number(s.unreadCount) || 0), 0)
        commit('SET_CHAT_UNREAD_TOTAL', total)
        return total
      } catch (e) {
        devError('fetchChatUnreadCount failed:', e)
        commit('SET_CHAT_UNREAD_TOTAL', 0)
        return 0
      }
    }
  }
})